<template>
  <div class="w-[100%]">
    <n-select
      v-model:value="internalValue"
      :placeholder="placeholder"
      :disabled="disabled"
      :clearable="true"
      :options="options"
      :size="size"
      :label-field="labelField"
      :value-field="valueField"
    ></n-select>
  </div>
</template>

<script setup lang="ts">
type SelectValue =
  | string
  | number
  | boolean
  | null
  | undefined
  | (string | number | boolean)[]

// 定义Emits接口
interface SelectFieldEmits {
  (e: 'update:modelValue', value: SelectValue): void
  (e: 'change', value: SelectValue): void
}
const props = defineProps<{
  modelValue: SelectValue
  placeholder?: string
  disabled?: boolean
  readonly?: boolean
  options: any[]
  multiple?: boolean
  filterable?: boolean
  labelField?: string // 如果显示的字段不一样 就需要传递
  valueField?: string
  size?: 'tiny' | 'small' | 'medium' | 'large'
  prefixIcon?: string
  prefixIconSize?: string | number
  [key: string]: any
}>()

const emit = defineEmits<SelectFieldEmits>()
const internalValue = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    emit('update:modelValue', value)
    emit('change', value)
  }
})
</script>
